<div class="col-xl">
    <form [formGroup]="trailerForm" id="formTrailer" (ngSubmit)="updateTrailer()">
        <div class="card mb-4">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h5 class="mb-0">Actualización de Remolque</h5>
            </div>
            <div class="card-body">
                <div class="mb-3 rounded p-3 border">
                    <div class="row">
                        <h5 class="mb-0">Datos del Remolque</h5>
                    </div>
                    <div class="row mt-3">
                        <div class="col">
                            <label class="form-label">Nombre del remolque*</label>
                            <input type="text" class="form-control" [(ngModel)]="formModelData.trailer"
                                [ngClass]="trailerForm.controls['trailer'].errors && !trailerForm.controls['trailer'].pristine ? 'is-invalid' : ''"
                                formControlName="trailer">
                        </div>
                        <div class="col">
                            <label class="form-label">Año del remolque*</label>
                            <input type="date" class="form-control" [(ngModel)]="formModelData.year"
                                [ngClass]="trailerForm.controls['year'].errors && !trailerForm.controls['year'].pristine ? 'is-invalid' : ''"
                                formControlName="year">
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col">
                            <label class="form-label">Placas*</label>
                            <input type="text" class="form-control" [(ngModel)]="formModelData.plate"
                                [ngClass]="trailerForm.controls['plate'].errors && !trailerForm.controls['plate'].pristine ? 'is-invalid' : ''"
                                formControlName="plate">
                        </div>
                        <div class="col">
                            <label class="form-label">Crear checklist del estado de mantenimiento*</label><br>
                            <a href="javascript:void(0)" (click)="goToChecklist()" class="evidence-link">Subir checklist del estado de mantenimiento</a>
                        </div>
                    </div>
                </div>

                <div class="mb-3 p-3 rounded border">
                    <div class="row">
                        <h5 class="mb-0">Datos de carta porte</h5>
                    </div>
                    <div class="row mt-3">
                        <div class="col">
                            <label class="form-label">Clave de tipo remolque*</label>
                            <select class="form-control" [(ngModel)]="formModelData.trailer_type_id"
                                [ngClass]="trailerForm.controls['trailer_type_id'].errors && !trailerForm.controls['trailer_type_id'].pristine ? 'is-invalid' : ''"
                                formControlName="trailer_type_id">
                                <option value="">Seleccione una opción</option>
                                <option *ngFor="let t of trailerTypes" [value]="t.id">{{t.key}} - {{t.name}}</option>
                            </select>
                        </div>

                        <div class="col">
                            <label class="form-label">Activo*</label>
                            <div class="form-check mt-2">
                                <input class="form-check-input" type="checkbox" id="trailerActive"
                                    [(ngModel)]="formModelData.active" formControlName="active">
                                <label class="form-check-label" for="trailerActive">Activo</label>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="card mb-4">
            <div class="card-body text-center">
                <button type="submit" class="btn btn-primary me-sm-3 me-1">Actualizar Remolque</button>
            </div>
        </div>
    </form>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>
